<app-masterheader></app-masterheader>

<div class="wrapper">

  <app-sidebar ></app-sidebar>

<div id="content">
  <div class="container-fluid" style="background-color: #ffffff;">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-dark text-white text-center">
            <h4 class="mb-0"> Annual Plan of Operation</h4>
          
            <div class="mt-2 d-flex justify-content-center gap-2 flex-wrap">
              <a class="btn btn-sm btn-outline-light" href="/assets/APO_DOCUMENTS/APO_User_Manual_v1_English.pdf" target="_blank">
                📘 English Manual
              </a>
              <a class="btn btn-sm btn-outline-light" href="/assets/APO_DOCUMENTS/APO_User_Manual_v1_Odia.pdf" target="_blank">
                📗 ଓଡିଆ ମାନୁଆଲ୍ (Odia Manual)
              </a>
            </div>
          </div>
          <div class="card-body">
            <div class="custom-accordion">

    <!-- Map View Panel -->
    <div class="accordion-panel" *ngIf="isReadOnly">
      <div class="accordion-header" (click)="togglePanel('map')">
        <h5>Annual Plan Operation Details</h5>
        <span>{{ openPanels.map ? '−' : '+' }}</span>
      </div>
      <div class="accordion-content" *ngIf="openPanels.map">
        <div class="panel-content">
          <div class="row col-md-12">
            <div class="col-md-6">
              <table class="table table-striped">
                <tbody class="custom-table">
                  <tr>
                    <td class="p-3 font-tag-style">Financial Year</td>
                    <td class="p-3 font-tag-style f-w-800">2025-2026</td>
                  </tr>
                  <tr>
                    <td class="p-3 font-tag-style">Circle</td>
                    <td class="p-3 font-tag-style f-w-800">{{apoRequest?.circleName}}</td>
                  </tr>
                  <tr>
                    <td class="p-3 font-tag-style">Division</td>
                    <td class="p-3 font-tag-style f-w-800">{{apoRequest?.divName}}</td>
                  </tr>
                  <tr *ngIf="apoRequest?.rangeName">
                    <td class="p-3 font-tag-style">Range</td>
                    <td class="p-3 font-tag-style f-w-800">{{apoRequest?.rangeName}}</td>
                  </tr>
                  <tr>
                    <td class="p-3 font-tag-style">Major Scheme</td>
                    <td class="p-3 font-tag-style f-w-800">{{apoRequest?.schemeName}}</td>
                  </tr>
                  <tr>
                    <td class="p-3 font-tag-style">Scheme Details</td>
                    <td class="p-3 font-tag-style f-w-800">{{apoRequest?.subSchemeName}}</td>
                  </tr>
                  <tr>
                    <td class="p-3 font-tag-style">Component</td>
                    <td class="p-3 font-tag-style f-w-800">{{apoRequest?.componentName}}</td>
                  </tr>
                  <tr>
                    <td class="p-3 font-tag-style">Report</td>
                    <td class="p-3 font-tag-style f-w-800">{{apoRequest?.reportName}}</td>
                  </tr>
    
    
    
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
    
              <app-apomap [mapinfo]="mapinfo"></app-apomap>
              <!-- <p *ngIf="!gpsCoordinates.length">No GPS coordinates available.</p> -->
    
            </div>
          </div>
        </div>
    
      </div>
    </div>
    
    <!-- View Form Panel -->
    <div class="accordion-panel">
      <div class="accordion-header" (click)="togglePanel('view')" *ngIf="isReadOnly">
        <h5>Annual Plan Operation ({{yearRange}})</h5>
        <span>{{ openPanels.view ? '−' : '+' }}</span>
      </div>
      <div class="accordion-content" *ngIf="openPanels.view">
        <div class="panel-content">
    
    
          <!-- Reactive Form for Dropdowns -->
          <div class="filter-card ">
            <form [formGroup]="apoForm" novalidate *ngIf="!isReadOnly">
              <div class="row g-2 align-items-end filter-row">
                <div class="col">
                  <label for="financialYear" class="form-label">Financial Year</label>
                  <div class="form-control financial-year-static">{{ yearRange }}</div>
                </div>
                <div class="col">
                  <label for="majorScheme" class="form-label">Major Scheme</label>
                  <select id="majorScheme" class="form-control" formControlName="scheme" (change)="onSchemeChange($event.target.value)">
                    <option value="0">All Major Scheme</option>
                    <option *ngFor="let scheme of schemeList" [value]="scheme.id">{{ scheme.name }}</option>
                  </select>
                </div>
                <div class="col">
                  <label for="schemeDetails" class="form-label">Scheme Details</label>
                  <select id="schemeDetails" class="form-control" formControlName="subscheme" (change)="onSubSchemeChange($event.target.value)">
                    <option value="0">All Schemes</option>
                    <option *ngFor="let scheme of subSchemeList" [value]="scheme.id">{{ scheme.name }}</option>
                  </select>
                </div>
                <div class="col">
                  <label for="component" class="form-label">Component</label>
                  <select id="component" class="form-control" formControlName="component" (change)="onSelectComponent($event.target.value)">
                    <option value="0">All Component</option>
                    <option *ngFor="let component of componentList" [value]="component.id">{{ component.name }}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <!-- <div class="col-md-12" *ngIf="apoForm.get('component')?.value!='0'">
                          <button type="button" class="btn btn-sm btn-primary" (click)="downoladExcelForm(apoForm.get('component')?.value)">Download Excel</button>
                        </div> -->
          <!-- Download Excel Button *ngIf="apoForm.get('component')?.value != '0' && !isReadOnly "-->
    
          <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap" *ngIf="tableData.length > 0 && !isReadOnly">
            <span class="land-based-activity-badge">
              <span style="color: #d32f2f; font-weight: bold; font-size: 1.1em;">***</span> It is Land Based Activity
            </span>
            <div>
              <button type="button" class="notice-btn download" (click)="downloadAsExcel()">
                <i class="fa fa-download me-1"></i> Download Sample Excel
              </button>
              <button type="button" class="notice-btn upload" (click)="openExcelFormModal()">
                <i class="fa fa-upload me-1"></i> Upload Excel
              </button>
            </div>
          </div>
    
          <!-- Template-Driven Form for Table -->
          <form class="needs-validation" (ngSubmit)="submitData()" novalidate *ngIf="tableData.length > 0  ">
            <!-- Report Table -->
            <div class="table-responsive mt-4" style="max-height: 80vh; overflow-y: auto;">
              <table class="table table-bordered">
                <thead class="table-header sticky-top bg-dark">
                  <tr>
                    <th id="formtitle" [attr.colspan]="dynamicFields.length + 2" class="p-3 text-white">
                      {{ formTitle }} <small class="text-white-50">
                        <pre>{{ formDesc }}</pre>
                      </small>
                    </th>
                  </tr>
                  <tr>
                    <th id="slno" rowspan="3" class="align-middle text-white">Sl. No.</th>
                    <ng-container *ngFor="let group of getHeaderGroups()">
                      <ng-container *ngIf="group.type === 'standalone'">
                        <th [attr.rowspan]="group.fields[0].rowspan || 2" class="align-middle text-white">{{ group.name
                          }}</th>
                      </ng-container>
                      <ng-container *ngIf="group.type === 'superGroup'">
                        <th [attr.colspan]="calculateTotalFields(group)" class="align-middle text-white text-center">{{
                          group.name }}</th>
                      </ng-container>
                    </ng-container>
                    <th rowspan="3" class="align-middle bg-dark text-white" *ngIf="!isViewMode && !isReadOnly">Action</th>
                  </tr>
                  <tr>
                    <ng-container *ngFor="let group of getHeaderGroups()">
                      <ng-container *ngIf="group.type === 'superGroup'">
                        <ng-container *ngFor="let subGroup of group.subGroups || []">
                          <th *ngIf="subGroup.name" [attr.colspan]="subGroup.fields.length"
                            class="align-middle bg-secondary text-white text-center">{{ subGroup.name }}</th>
                        </ng-container>
                        <ng-container *ngIf="!group.subGroups || group.subGroups.length === 0">
                          <th *ngFor="let field of group.fields" [attr.rowspan]="field.rowspan || 2"
                            class="align-middle bg-dark text-white">{{ field.label }}</th>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr>
                    <ng-container *ngFor="let group of getHeaderGroups()">
                      <ng-container *ngIf="group.type === 'superGroup'">
                        <ng-container *ngFor="let subGroup of group.subGroups || []">
                          <th *ngFor="let field of subGroup.fields" [attr.rowspan]="field.rowspan || 2"
                            class="align-middle text-white">{{ field.label }}</th>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="group.type === 'standalone' && group.fields[0].rowspan === 2">
                        <th *ngFor="let field of group.fields" [attr.rowspan]="field.rowspan || 2"
                          class="align-middle text-white">{{ field.label }}</th>
                      </ng-container>
                    </ng-container>
                  </tr>
                </thead>
    
                <tbody>
                  <!-- (click)="currentRow = row" -->
                  <tr *ngFor="let row of tableData; let i = index; trackBy: trackByIndex"  [class.row-saved]="row.isSaved" [class.non-editable-bold]="row.hasChildren" (click)="onRowClick(row)">
                    <td class="fw-bold" [style.padding-left]="getIndentPadding(row)" [ngClass]="{'field-saved': row.isSaved}">
                      <span>{{ row.serial }}</span>
                      <span class="text-danger" *ngIf="row.islandBased"> *** </span>
                    </td>
                    <td [ngClass]="{'field-saved': row.isSaved}">
                      <span [innerHTML]="cleanItemName(row.itemName)"></span>
                    </td>
                    <ng-container *ngFor="let field of dynamicFields">
                      <td *ngIf="field.editable" [ngClass]="{'field-saved': row.isSaved}">
                        <ng-container *ngIf="isReadOnly ||!shouldShowEditableField(row) || !field.editable">
                          <span>{{ row.data[field.name] || '' }}</span>
                        </ng-container>
                        <ng-container *ngIf="shouldShowEditableField(row) && field.editable">
                          <input *ngIf="field.type === 'number'" type="number" class="form-control form-control-sm"
                            [(ngModel)]="row.data[field.name]" (ngModelChange)="updateAmountRequired(row)"
                            [ngModelOptions]="{standalone: true}" [name]="'field_' + row.serial + '_' + field.name"
                            [readonly]="isReadOnly  || row.isSaved || field.name === 'amountRequired'" step="0.01" min="0"
                            required [ngClass]="{'is-invalid': showFieldError(row, field.name), 'field-saved': row.isSaved}"
                            (blur)="onFieldBlur(field.name, row)">
    
                          <input *ngIf="field.type === 'text'" type="text" class="form-control form-control-sm"
                            [(ngModel)]="row.data[field.name]" (ngModelChange)="updateAmountRequired(row)"
                            [ngModelOptions]="{standalone: true}" [name]="'field_' + row.serial + '_' + field.name"
                            [readonly]="isReadOnly || row.isSaved " required
                            [ngClass]="{'is-invalid': showFieldError(row, field.name), 'field-saved': row.isSaved}"
                            (blur)="onFieldBlur(field.name, row)">
    
                          <div class="dropdown-container" (click)="$event.stopPropagation()"
                            *ngIf="field.type === 'dropdown' && (field.name === 'itemDD' ? row.dropdownOptions : row.unitDropdownOptions)?.length > 0">
                            <select class="form-control form-control-sm dropdown-fixed-width"
                              [ngClass]="{'is-invalid': showFieldError(row, field.name), 'field-saved': row.isSaved}"
                              [(ngModel)]="row.data[field.name]"
                              [disabled]="field.name === 'itemDD' || row.isSaved"
                              [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="onDropdownChange($event, row, field.name)">
                              <option *ngFor="let option of (field.name === 'itemDD' ? row.dropdownOptions : row.unitDropdownOptions)" [value]="option.value">
                                {{ option.label }}
                              </option>
                            </select>
                            <!-- <button *ngIf="!isReadOnly && !row.isSaved" 
                                                    class="btn btn-sm btn-primary ms-2 add-option-btn" 
                                                    type="button"
                                                    title="Add another option"
                                                     (click)="addNewRow(row);"
                                                    [disabled]="row.isSaved || isReadOnly || row.dropdownOptions?.length <= 1"
                                                   >
                                              <i class="fas fa-plus"></i>
                                            </button> -->
                            <!-- <button class="btn btn-danger btn-sm" 
                                                type="button"
                                                 title="Remove option"
                                                 (click)="removeRow(row)"
                                              [disabled]="row.isSaved || isReadOnly || tableData.length <= 1">
                                               <i class="fa fa-times" aria-hidden="true"></i>
    
                                            </button> -->
                          </div>
    
                          <div *ngIf="showFieldError(row, field.name)" class="invalid-feedback">
                            {{ getFieldError(row, field.name) }}
                          </div>
                        </ng-container>
    
                      </td>
                    </ng-container>
    
                    <td class="text-nowrap" *ngIf="!isReadOnly">
                      <!-- <button class="btn btn-sm btn-primary" *ngIf="row.editableIndex !== undefined" [disabled]="row.isSaved"
                                        (click)="openSiteSpecificationModal(row)" type="button">
                                        <i class="fas fa-info-circle"></i> Site Specification
                                      </button> -->
    
                      <button *ngIf="!row.isSaved && shouldShowEditableField(row) && row.editableIndex !== undefined"
                        class="btn btn-sm btn-success me-2" (click)="saveRow(row)" type="button">
                        <i class="fas fa-save"></i> Save
                      </button>
    
                      <button *ngIf="row.isSaved && shouldShowEditableField(row)" class="btn btn-sm btn-warning me-2"
                        (click)="editRow(row)" type="button">
                        <i class="fas fa-edit"></i> Edit
                      </button>
                      <button *ngIf="shouldShowEditableField(row)" class="btn btn-sm btn-danger  me-2"
                        (click)="resetRow(row)" type="button">
                        <i class="fas fa-undo"></i> Reset
                      </button>
                      <!-- [disabled]="!row.isSaved" -->
                      <div class="button-wrapper" *ngIf="row.editableIndex !== undefined">
                        <span class="badge badge-count">
                          {{row.siteSpecifictaionCount}}
                        </span>
                        <button class="btn btn-sm btn-info" (click)="openModal(row)" type="button">
                          <i class="fas fa-info-circle"></i> Site Specification
                        </button>
                      </div>
    
    
                    </td>
                  </tr>
                  <!-- <ng-container *ngFor="let site of executionPaginatedData">
                    <tr *ngIf="site.showAuditTimeline">
                      <td colspan="7">
                        <div class="audit-timeline-drawer p-3">
                          <ul class="timeline">
                            <li *ngFor="let log of site.auditLogs">
                              <span class="fw-bold">{{ log.action }}</span> by <span class="text-primary">{{ log.user }}</span> on <span class="text-muted">{{ log.date | date:'short' }}</span>
                              <div class="text-secondary small">{{ log.remarks }}</div>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="executionPaginatedData.length === 0">
                    <td colspan="7" class="text-center">No records found.</td>
                  </tr> -->
                </tbody>
              </table>
            </div>

            <!-- Totals below the form, only in view mode -->
            <div *ngIf="isViewMode" class="d-flex flex-wrap gap-3 justify-content-end mt-3">
              <ng-container *ngFor="let field of dynamicFields">
                <span *ngIf="['amountRequired','financialTarget','financialTargetCurr','amountINR'].includes(field.name)" class="total-amount-box bg-light border rounded px-4 py-2 shadow-sm d-flex align-items-center">
                  <i class="fas fa-rupee-sign text-success me-2"></i>
                  <span class="fw-bold text-secondary">Total {{ field.label }}: </span>
                  <span class="fw-bold text-success ms-2" style="font-size: 1.2rem;">{{ getTotalForField(field.name) | number:'1.2-2' }}</span>
                </span>
              </ng-container>
            </div>
    
            <div class="d-flex justify-content-between align-items-center mt-4" *ngIf="!isReadOnly">
              <div></div>
             
              <div>
                <button type="button" class="btn btn-success me-2" (click)="saveAllRows()">Save All</button>
                <button type="button" class="btn btn-sm btn-warning me-2" (click)="resetAllRows()"
                  [disabled]="tableData.length===0">
                  <i class="fas fa-undo-alt"></i> Reset All
                </button>
                <!-- [disabled]="!allRowsSaved" -->
                <button type="submit" class="btn btn-primary px-4">
                  Final Submit
                </button>
              </div>
               <div class="total-amount-box bg-light border rounded px-4 py-2 ms-3 shadow-sm d-flex align-items-center">
                <i class="fas fa-rupee-sign text-success me-2"></i>
                <span class="fw-bold text-secondary">Total Amount Entered: </span>
                <span class="fw-bold text-success ms-2" style="font-size: 1.2rem;">{{ totalAmountEntered | number:'1.2-2' }}</span>
              </div>
            </div>
            <div *ngIf="!allRowsSaved && !isReadOnly" class="text-warning mt-2 text-end" >
              Please save all rows before submitting
            </div>
          </form>
        </div>
      </div>
    </div>

              <!-- Execution Panel -->
              <!-- <div class="accordion-panel" *ngIf="isReadOnly">
                <div class="accordion-header" (click)="togglePanel('execution')">
                  <h5>Execution Documents</h5>
                  <span>{{ openPanels.execution ? '−' : '+' }}</span>
                </div>
                <div class="accordion-content" *ngIf="openPanels.execution">
                  <div class="panel-content">
                    <div class="tabs">
                      <button class="tab-button" [class.active]="activeTab === 'kml'" (click)="setActiveTab('kml')">KML File</button>
                      <button class="tab-button" [class.active]="activeTab === 'images'" (click)="setActiveTab('images')">Before/After Images</button>
                      <button class="tab-button" [class.active]="activeTab === 'plan'" (click)="setActiveTab('plan')">Plan/Estimate</button>
                      <button class="tab-button" [class.active]="activeTab === 'dpr'" (click)="setActiveTab('dpr')">DPR</button>
                      <button class="tab-button" [class.active]="activeTab === 'tender'" (click)="setActiveTab('tender')">Tender Document</button>
                      <button class="tab-button" [class.active]="activeTab === 'workorder'" (click)="setActiveTab('workorder')">Work Order</button>
                      <button class="tab-button" [class.active]="activeTab === 'completion'" (click)="setActiveTab('completion')">Completion Certificate</button>
                    </div>
                    <div class="tab-content">
                      <div class="tab-pane" *ngIf="activeTab === 'kml'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="kmlFile">Upload KML File</label>
                            <input type="file" class="form-control" id="kmlFile" formControlName="kmlFile" accept=".kml" (change)="onFileChange($event, 'kmlFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'images'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="beforeImage">Before Image</label>
                            <input type="file" class="form-control" id="beforeImage" formControlName="beforeImage" accept=".jpg,.jpeg,.png" (change)="onFileChange($event, 'beforeImage')">
                          </div>
                          <div class="form-group">
                            <label for="afterImage">After Image</label>
                            <input type="file" class="form-control" id="afterImage" formControlName="afterImage" accept=".jpg,.jpeg,.png" (change)="onFileChange($event, 'afterImage')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'plan'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="planFile">Upload Plan/Estimate</label>
                            <input type="file" class="form-control" id="planFile" formControlName="planFile" accept=".pdf" (change)="onFileChange($event, 'planFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'dpr'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="dprFile">Upload DPR</label>
                            <input type="file" class="form-control" id="dprFile" formControlName="dprFile" accept=".pdf" (change)="onFileChange($event, 'dprFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'tender'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="tenderFile">Upload Tender Document</label>
                            <input type="file" class="form-control" id="tenderFile" formControlName="tenderFile" accept=".pdf" (change)="onFileChange($event, 'tenderFile')">
                          </div>

                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'workorder'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="workOrderFile">Upload Work Order</label>
                            <input type="file" class="form-control" id="workOrderFile" formControlName="workOrderFile" accept=".pdf" (change)="onFileChange($event, 'workOrderFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'completion'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="completionFile">Upload Completion Certificate</label>
                            <input type="file" class="form-control" id="completionFile" formControlName="completionFile" accept=".pdf" (change)="onFileChange($event, 'completionFile')">
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="form-actions">
                      <button class="btn btn-sm btn-primary custom-btn" >Submit</button>
                    </div>
                  </div>
                </div>
              </div> -->

               <div class="accordion-panel" *ngIf="isReadOnly">
                <div class="accordion-header" (click)="togglePanel('execution')">
                  <h5>Site Specification</h5>
                  <span>{{ openPanels.execution ? '−' : '+' }}</span>
                </div>
                <div class="accordion-content" *ngIf="openPanels.execution">
                  <div class="panel-content">
                        
                 <!-- Execution Filter Form for Dropdowns --> 
                  <div class="card shadow-sm mb-4">
                    <div class="card-body">
                      <!-- Filter Section -->
                      <div class="filter-section mb-4 p-3 bg-light rounded">
                        <h5 class="filter-title mb-4 text-dark fw-semibold">
                          <i class="fa fa-filter me-2 text-primary"></i>Filter Options
                        </h5>
                        <!-- <form [formGroup]="siteSpecificationFilterForm" class="row align-items-end g-3">
                          <div class="col-md-3 col-sm-6">
                            <label for="apoId" class="form-label text-muted small">Item Name</label>
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-select formControlName="apoId" placeholder="Select Item Name" class="form-control">
                              
                                <mat-option>
                                  <input
                                    matInput
                                    placeholder="Search..."
                                    (input)="filterApoItems($event)"
                                    (click)="$event.stopPropagation()"
                                    class="w-100"
                                  />
                                </mat-option>
                                <mat-option value="">All</mat-option>
                                <mat-option *ngFor="let apo of filteredApoIdItemNameList" [value]="apo.apoId">
                                  {{ apo.itemName }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="documentTypeId" class="form-label text-muted small">Document Type</label>
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-select formControlName="documentTypeId" placeholder="Select Document Type" class="form-control">
                                <mat-option value="">All</mat-option>
                                <mat-option *ngFor="let type of executionList" [value]="type.id">
                                  {{ type.name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="fromDate" class="form-label text-muted small">From Date</label>
                            <input type="date" formControlName="fromDate" class="form-control" />
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="toDate" class="form-label text-muted small">To Date</label>
                            <input type="date" formControlName="toDate" class="form-control" />
                          </div>
                          <div class="col-md-3 d-flex align-items-end gap-2 justify-content-start">
                            <button type="button" class="btn btn-primary btn-sm me-2" (click)="applyExecutionFilter()">
                              <i class="fa fa-search me-1"></i> Search
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetExecutionFilters()">
                              <i class="fa fa-refresh me-1"></i> Reset
                            </button>
                          </div>
                        </form> -->
                        <form [formGroup]="siteSpecificationFilterForm" class="row align-items-end g-3">
                          <div class="col-md-3 col-sm-6">
                            <label for="mapId" class="form-label text-muted small">Item Name</label>
                            <select class="form-control" formControlName="mapId" (change)="getDDTypeList([($event.target.value)])">
                              <option value="">All</option>
                              <option *ngFor="let item of apoIdItemNameList" [value]="item.mapId">{{ item.itemName }}</option>
                            </select>
                          </div>
                           <div class="col-md-3 col-sm-6"  *ngIf="typeListform?.length>0">
                            <label for="typeId" class="form-label text-muted small">Type Name</label>
                            <select class="form-control" formControlName="typeId">
                              <option value="">All</option>
                              <option *ngFor="let item of typeListform" [value]="item.typeId">{{ item.ddValue }}</option>
                            </select>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="siteWorkType" class="form-label text-muted small">Site Work Type</label>
                            <select class="form-control" formControlName="siteWorkType">
                                <option value="">All</option>
                              <option  value="1">Site Specification</option>
                               <option  value="2">Site Execution</option>
                            </select>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="status" class="form-label  text-muted small">Status</label>
                            <select class="form-control" formControlName="status">
                              <option value="">All</option>
                              <option value="Draft">Submitted</option>
                              <option value="Approved">Approved</option>
                              <option value="Rejected">Rejected</option>
                              <option value="Resubmitted">Resubmitted</option>
                              <!-- <option value="Pending">Pending</option> -->
                            </select>
                          </div>
                          <!-- <div class="col-md-3 col-sm-6">
                            <label for="documentTypeId" class="form-label text-muted small">Document Type</label>
                            <select class="form-control" formControlName="documentTypeId">
                              <option value="">All</option>
                              <option *ngFor="let type of executionList" [value]="type.id">{{ type.name }}</option>
                            </select>
                          </div>
                   -->
                          <div class="col-md-3 col-sm-6">
                            <label for="fromDate" class="form-label text-muted small">From Date</label>
                            <input type="date" formControlName="fromDate" class="form-control" />
                          </div>
                  
                          <div class="col-md-3 col-sm-6">
                            <label for="toDate" class="form-label text-muted small">To Date</label>
                            <input type="date" formControlName="toDate" class="form-control" />
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="searchText" class="form-label  text-muted small">Search</label>
                            <input type="text" class="form-control" formControlName="searchText" placeholder="Site Name, Remarks...">
                          </div>
                          <div class="col-md-3 d-flex align-items-end  gap-2  justify-content-start">
                            <button type="button" class="btn btn-primary btn-sm me-2" (click)="applyExecutionFilter()">
                              <i class="fa fa-search me-1"></i> Search
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetExecutionFilters()">
                              <i class="fa fa-refresh me-1"></i> Reset
                            </button>
                          </div>
                  
                        </form>
                      </div>
                    </div>
                  </div>

                        <div class="card shadow-sm">
                          <div class="card-body table-responsive">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              
                                <h6 class="text-secondary m-0">
                                  <i class="fa fa-list me-2"></i> List of Records
                                </h6>
                                <button class="btn btn-success  float-right" type="button" (click)="downloadExecutionListAsExcel()">
                                  <i class="fa fa-file-excel-o me-1"></i> Excel
                                </button>
                             
                              
                            </div>
                            
                            <table class="table table-hover table-bordered">
                              <thead class="thead-dark">
                                <tr>
                                  <th>Sl.No.</th>
                                  <th>Item Name</th>
                                  <th>Type Name</th>
                                  <th>Site Specification Status</th>
                                  <th>Execution Status</th>
                                  <th>Remarks</th>
                                  <th>Resubmission Deadline</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let site of executionPaginatedData; let i = index">
                                  <td>{{ i + 1 }}</td>
                                  <td>{{ site.taskName }}</td>
                                  <td>{{site.typeName	}}</td>
                                  <td>
                                     <span
                                        [ngClass]="{
                                          'badge bg-success': site.justificationStatus === 'Approved',
                                          'badge bg-danger': site.justificationStatus === 'Rejected',
                                          'badge bg-warning': site.justificationStatus === 'Submitted' || site.justificationStatus === 'Draft',
                                          'badge bg-info': site.justificationStatus === 'Resubmitted'
                                        }"
                                      >
                                        {{ site.justificationStatus || '-' }}
                                      </span>
                                  </td>
                                  <td>
                                    <span
                                        [ngClass]="{
                                          'badge bg-success': site.executionStatus === 'Approved',
                                          'badge bg-danger': site.executionStatus === 'Rejected',
                                          'badge bg-warning': site.executionStatus === 'Submitted' || site.executionStatus === 'Draft',
                                          'badge bg-info': site.executionStatus === 'Resubmitted'
                                        }"
                                      
                                      >
                                        {{ site.executionStatus || '-' }}
                                      </span>
                                  </td>
                                  <td>
                                    <!-- <span *ngIf="site.justificationStatus === 'Rejected' || site.executionStatus === 'Rejected'" class="text-danger fw-bold">
                                      <i class="fa fa-exclamation-circle me-1"></i>
                                      {{ site.rejectionRemarks }}
                                    </span>
                                    <span *ngIf="!site.rejectionRemarks">{{ site.siteRemarks }}</span> -->
                                     <!-- Show rejection remarks for justification, else for execution, else siteRemarks -->
                                      <span *ngIf="site.justificationStatus === 'Rejected' && site.justificationRejectionRemarks" class="text-danger">
                                        <i class="fa fa-exclamation-circle me-1"></i>{{ site.justificationRejectionRemarks }}
                                      </span>
                                      <span *ngIf="site.executionStatus === 'Rejected' && site.executionRejectionRemarks" class="text-danger">
                                        <i class="fa fa-exclamation-circle me-1"></i>{{ site.executionRejectionRemarks }}
                                      </span>
                                      <span *ngIf="!site.justificationRejectionRemarks && !site.executionRejectionRemarks">
                                        {{ site.siteRemarks || '-' }}
                                      </span>
                                  </td>
                                  <td>
                                    <span *ngIf="site.justificationStatus === 'Rejected' && site.justificationResubmitDeadline" class="text-danger">
                                      <i class="fa fa-clock me-1"></i>{{ site.justificationResubmitDeadline | date: 'medium' }}
                                    </span>
                                    <span *ngIf="site.executionStatus === 'Rejected' && site.executionResubmitDeadline" class="text-danger">
                                      <i class="fa fa-clock me-1"></i>{{ site.executionResubmitDeadline | date: 'medium' }}
                                    </span>
                                    <span *ngIf="!site.justificationResubmitDeadline && !site.executionResubmitDeadline">-</span>
                                  </td>
                                  <!-- <td class="action-buttons">
                                    <button class="btn btn-success rounded-pill shadow-sm me-2" title="Approve" (click)="takeExecutionAction(site.apoSiteId, 'APPROVE')">
                                      <i class="fa fa-check"></i>
                                    </button>
                                    <button class="btn btn-danger rounded-pill shadow-sm me-2" title="Reject" >
                                      <i class="fa fa-times"></i>
                                    </button>
                                    <button class="btn btn-primary rounded-pill shadow-sm me-2" title="Resubmit" *ngIf="site.justificationStatus === 'Rejected' || site.executionStatus === 'Rejected'" (click)="openResubmitModal(site)">
                                      <i class="fa fa-repeat"></i>
                                    </button>
                                    <button class="btn btn-info rounded-pill shadow-sm" title="Audit Timeline" (click)="toggleAuditTimeline(site)">
                                      <i class="fa fa-history"></i>
                                    </button>
                                  </td> -->
                                  <td class="action-buttons">
                                    <!-- View button (all roles) -->
                                    <button type="button" class="btn btn-sm btn-outline-primary rounded-pill mr-1" (click)="openSiteDetailsModal(site)">
                                      <i class="fa fa-eye"></i> View
                                    </button>

                                    <!-- === Range User (roleId == 12) === -->
                                    <ng-container *ngIf="roleId == 12">
                                      <!-- Justification: Only submit if status Rejected and resubmit allowed -->
                                      <button *ngIf="site.justificationStatus === 'Rejected' && canResubmitJustificationInTimeBound(site)"
                                              class="btn btn-success btn-sm rounded-pill mr-1"
                                              (click)="submitJustification(site.apoSiteId)">
                                        <i class="fa fa-repeat"></i> Re Submit Site Specification
                                      </button>
                                      <!-- After justification approved, show execution submit -->
                                      <button *ngIf="site.justificationStatus === 'Approved' && site.executionStatus === 'Draft'"
                                              class="btn btn-success btn-sm rounded-pill mr-1"
                                               (click)="openExecutionModal(site)">
                                        <i class="fa fa-paper-plane"></i> Submit Execution
                                      </button>
                                      <button *ngIf="site.justificationStatus === 'Approved' && site.executionStatus === 'Rejected' && canResubmitExecutionInTimeBound(site)"
                                              class="btn btn-success btn-sm rounded-pill mr-1"
                                              (click)="submitExecution(site.apoSiteId)">
                                        <i class="fa fa-repeat"></i> Re Submit Execution
                                      </button>
                                    </ng-container>

                                    <!-- === Division User (roleId == 11) === -->
                                    <ng-container *ngIf="roleId == 11">
                                      <!-- Approve/Reject Justification if status is Submitted -->
                                      <ng-container *ngIf="site.justificationStatus === 'Draft' || site.justificationStatus === 'Submitted'">
                                        <button *ngIf="roleId == 11 && (site.justificationStatus === 'Draft' || site.justificationStatus === 'Submitted')"
                                                class="btn btn-success btn-sm rounded-pill mr-1"
                                                (click)="openApproveConfirm(site.apoSiteId, 'justification')">
                                          <i class="fa fa-check"></i> Approve Site Specification
                                        </button>
                                        <button class="btn btn-danger btn-sm rounded-pill" (click)="openRejectJustificationModal(site)">
                                          <i class="fa fa-times"></i> Reject Site Specification
                                        </button>
                                      </ng-container>
                                      <!-- Allow Resubmit for justification -->
                                      <!-- <ng-container *ngIf="site.justificationStatus === 'Reject' && canResubmitJustificationInTimeBound(site)">
                                        <button class="btn btn-primary btn-sm rounded-pill" (click)="allowResubmitJustification(site.apoSiteId)">
                                          <i class="fa fa-repeat"></i> Allow Resubmit
                                        </button>
                                      </ng-container> -->
                                      <!-- Approve/Reject Execution if status is Submitted -->
                                      <ng-container *ngIf="site.justificationStatus === 'Approved' && site.executionStatus === 'Submitted'">
                                        <button *ngIf="roleId == 11 && site.justificationStatus === 'Approved' && site.executionStatus === 'Submitted'"
                                                class="btn btn-success btn-sm rounded-pill mr-1"
                                                (click)="openApproveConfirm(site.apoSiteId, 'execution')">
                                          <i class="fa fa-check"></i> Approve Execution
                                        </button>
                                        <button class="btn btn-danger btn-sm rounded-pill" (click)="openRejectExecutionModal(site)">
                                          <i class="fa fa-times"></i> Reject Execution
                                        </button>
                                      </ng-container>
                                      <!-- Allow Resubmit for execution -->
                                      <!-- <ng-container *ngIf="site.executionStatus === 'Rejected' && canResubmitExecutionInTimeBound(site)">
                                        <button class="btn btn-primary btn-sm rounded-pill" (click)="allowResubmitExecution(site.apoSiteId)">
                                          <i class="fa fa-repeat"></i> Allow Resubmit Execution
                                        </button>
                                      </ng-container> -->
                                    </ng-container>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                  
                            <!-- Pagination -->
                             <nav *ngIf="executionCurrentPage > 1" aria-label="Page navigation example">
                              <ul class="pagination justify-content-center">
                                <li class="page-item" [class.disabled]="executionCurrentPage === 1">
                                  <a class="page-link" (click)="changePage(executionCurrentPage - 1)">Previous</a>
                                </li>
                  
                                <li class="page-item" *ngFor="let page of executionPagesArray" [class.active]="page === executionCurrentPage">
                                  <a class="page-link" (click)="changePage(page)">{{ page }}</a>
                                </li>
                  
                                <li class="page-item" [class.disabled]="executionCurrentPage === executionTotalPages">
                                  <a class="page-link" (click)="changePage(executionCurrentPage + 1)">Next</a>
                                </li>
                              </ul>
                            </nav> 
                  
                          </div>
                        </div>
                  
                  </div>
                </div>
              </div>

          


          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal for Additional Information -->
 <div class="modal fade modern-modal " [class.show]="isModalOpen" [style.display]="isModalOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="additionalInfoModal" [attr.aria-hidden]="!isModalOpen">
  <div class="modal-dialog  modal-xl">
    <div class="modal-content">
      <div class="modal-header modern-header">
        <h5 class="modal-title bold-text" id="additionalInfoModal">Site Specification 
           <span class="text-muted-1  me-auto" *ngIf="currentRow?.data['unitDD'] == '3' ||  currentRow?.data['unitPrev'] == '3' || currentRow?.data['unitCurr'] == '3'">
          [ Total Sites: <span class="badge bg-info">{{ sites.length }}</span>
          / Required: <span class="badge bg-warning">{{ getRequiredSiteCount() }}</span>
           ]
        </span>
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close">X</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="modalForm" class="needs-validation" novalidate>
          <!-- Remarks/Justification -->
          <div class="card mb-3 shadow-sm">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">1. Remarks/Justification</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="remarks" class="form-label bold-text">Remarks/Justification</label>
                  <textarea class="form-control form-control-sm" id="remarks" formControlName="remarks"
                            maxlength="300" rows="4" placeholder="Enter your remarks (max 300 characters)"
                            (input)="updateCharCount()"
                            [ngClass]="{'is-invalid': modalForm.get('remarks')?.invalid && modalForm.get('remarks')?.touched}">
                  </textarea>
                  <div class="d-flex justify-content-between mt-1">
                    <small class="text-muted">Character count: {{ modalForm.get('remarks')?.value?.length || 0 }} / 300</small>
                    <small *ngIf="modalForm.get('remarks')?.value?.length > 300" class="text-danger">Character limit exceeded!</small>
                  </div>
                  <div *ngIf="modalForm.get('remarks')?.invalid && modalForm.get('remarks')?.touched" class="invalid-feedback">
                    Remarks must be between 1 and 300 characters.
                  </div>
                </div>
                <div class="col-md-12 text-end">
                  <button type="button" class="btn btn-sm btn-danger" (click)="resetRemarks()">Reset</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Map View Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">2. Map View</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="kmlFile" class="form-label bold-text">Geography (KML File)
                    <span class="text-danger bold-text" *ngIf="currentRow?.islandBased">*  ***KML file is Mandatory for Land Based Activity</span>
                    <small id="kmlFileHelp2" class="form-text text-muted text-danger" *ngIf="currentRow?.islandBased"></small>
                    
                  </label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control modern-input" id="kmlFile" formControlName="kmlFile" accept=".kml"
                      (change)="onKmlFileChange($event)" aria-describedby="kmlFileHelp">
                    <span class="file-name">{{ modalForm.get('kmlFile')?.value?.name || 'No file chosen' }}</span>
                  </div>
                  <div *ngIf="modalForm.get('kmlFile')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('kmlFile')?.errors?.invalidType }}
                  </div>
                  <small id="kmlFileHelp" class="form-text text-muted">Upload a .kml file for geographic data.</small>
                  <button type="button" class="btn btn-danger" (click)="unloadKMLFile()">Cancel</button>
                </div>
              </div>
              <!-- Map View Preview Subsection -->
              <div class="preview-subsection mb-4">
                <h6 class="bold-text mb-2">Map View Preview</h6>
                <div *ngIf="!modalForm.get('kmlFile')?.value" class="text-muted">No KML file selected.</div>
                <!-- <app-map-preview *ngIf="modalForm.get('kmlFile')?.value" [kmlFile]="modalForm.get('kmlFile')?.value"></app-map-preview> -->
                     <app-map-preview *ngIf="kmlFile" [kmlFile]="kmlFile"></app-map-preview>
              </div>
            </div>
          </div>

          <!-- Images Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">3. Images</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="beforeImage" class="form-label bold-text">Before Images</label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control" id="beforeImage" accept=".jpg,.jpeg,.png" multiple (change)="onBeforeImagesChange($event)" #beforeImageInput>
                    <small class="form-text text-muted">Upload up to 5 GeoTag  images (.jpg, .jpeg, .png, ≤5MB each). ({{ beforeImages.length }}/5 selected)</small>
                    <div *ngIf="beforeImageError" class="text-danger small mt-1 mr-1">{{ beforeImageError }}</div>
                    <button type="button"  [disabled]="beforeImages.length >= 5"
                    class="btn btn-outline-primary float-right" 
                    (click)="beforeImageInput.click()" 
                    style="border-top-left-radius: 0; border-bottom-left-radius: 0; ">
                      <i class="fa fa-plus">Upload from Device</i>
                    </button>
                    
                    <!-- <div class="d-flex flex-wrap mt-2">
                      <div *ngFor="let img of beforeImages; let i = index" class="me-2 mb-2 position-relative">
                        <img [src]="img.preview" class="img-thumbnail" style="width: 80px; height: 80px; object-fit: cover;">
                        <button type="button" class="btn-close position-absolute top-0 end-0" (click)="removeBeforeImage(i)" aria-label="Remove">X</button>
                      </div>
                    </div>  -->


                  </div>
                  <div  *ngIf="beforeImageError"  class="invalid-feedback d-block">
                   {{ beforeImageError }}
                  </div>
                  <!-- <div *ngIf="modalForm.get('beforeImage')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('beforeImage')?.errors?.invalidType }}
                  </div>
                  <small id="beforeImageHelp" class="form-text text-muted">Upload a GeoTag .jpg or .png image.</small>
                  <button class="btn btn-danger" (click)="unloadBeforeImage()">Cancel</button> -->
                  <!-- Images Preview Subsection -->
                  <div class="preview-subsection mb-4">
                    <p class="mb-1 small bold-text">Before Images Preview:</p>
                    <div *ngIf="beforeImages.length === 0" class="text-muted">No Before Images selected.</div>
                    <div class="d-flex flex-wrap gap-2 align-items-center" *ngIf="beforeImages.length > 0">
                      <div *ngFor="let img of beforeImages; let i = index" class="position-relative me-2 mb-2" style="display: flex; flex-direction: column; align-items: center;">
                        <div class="image-preview-container" [ngClass]="img.fileSource || 'internal'" style="position: relative; display: inline-block;">
                          <img [src]="img.preview" class="img-thumbnail" style="width: 80px; height: 80px; object-fit: cover;">
                          <div class="image-source-badge" [ngClass]="img.fileSource || 'internal'">
                            {{ img.fileSource === 'external' ? 'EXT' : 'INT' }}
                          </div>
                          <div class="image-source-indicator" [ngClass]="img.fileSource || 'internal'">
                            {{ img.fileSource === 'external' ? 'Asset' : 'Device' }}
                          </div>
                          <button type="button" class="badge bg-danger border-0 position-absolute top-0 end-0" style="right: -8px; top: -8px; width: 22px; height: 22px; border-radius: 50%; font-size: 1rem; display: flex; align-items: center; justify-content: center; z-index: 4;" (click)="removeBeforeImage(i)" aria-label="Remove">&times;</button>
                        </div>
                        <div *ngIf="img.coordinates" class="coordinates-container mt-1">
                          <div class="coordinates-badge text-center">
                            <small>
                              <div><span class="coord-label">Lat:</span> {{ img.coordinates.latitude.toFixed(6) }}</div>
                              <div><span class="coord-label">Lon:</span> {{ img.coordinates.longitude.toFixed(6) }}</div>
                            </small>
                          </div>
                        </div>
                      </div>
                      <button type="button" class="btn btn-outline-primary" [disabled]="beforeImages.length >= 5" (click)="beforeImageInput.click()" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                        <i class="fa fa-plus"> Add More</i>
                      </button>
                    </div>         
                  </div>
                          <!-- OR divider -->
                         <!-- Browse Asset Repository -->
                  <span class="mx-2 text-muted" style="font-weight: 500;">OR</span>

                 
                  <button
                    type="button"
                    class="btn btn-info"
                    [disabled]="beforeImages.length >= 5"
                    (click)="openAssetSelectModal('before')">
                    <i class="fa fa-database me-1"></i> Browse Asset Repository
                  </button>
                </div>
                <!-- <div class="col-md-6 mb-3">
                  <label for="afterImage" class="form-label bold-text">After Image</label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control modern-input" id="afterImage" formControlName="afterImage"
                      accept=".jpg,.jpeg,.png" (change)="onAfterImageChange($event)" aria-describedby="afterImageHelp">
                    <span class="file-name">{{ modalForm.get('afterImage')?.value?.name || 'No file chosen' }}</span>
                  </div>
                  <div *ngIf="modalForm.get('afterImage')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('afterImage')?.errors?.invalidType }}
                  </div>
                  <small id="afterImageHelp" class="form-text text-muted">Upload a GeoTag .jpg or .png image.</small>
                  <button class="btn btn-danger" (click)="unloadAfterImage()">Cancel</button>
                  <div class="preview-subsection mb-4">
                    <p class="mb-1 small bold-text">After Image:</p>
                    <div *ngIf="!afterImagePreview" class="text-muted">No After Image selected.</div>
                    <div *ngIf="geoTagAfterImgCoord" class="coordinates-container">
                      <div class="coordinates-badge">
                        <i class="bi bi-geo-alt-fill me-1 text-primary"></i>
                        <span class="coord-label">Lat:</span> {{ geoTagAfterImgCoord?.latitude.toFixed(6) }},
                        <span class="coord-label ms-3">Lon:</span> {{ geoTagAfterImgCoord?.longitude.toFixed(6) }}
                      </div>
                    </div>
                    <img *ngIf="afterImagePreview" [src]="afterImagePreview" alt="After Image Preview" class="img-thumbnail"
                      style="max-height: 150px; max-width: 100%;">
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <!-- Documents Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">4. Documents</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="pdfFile" class="form-label bold-text">Supportive Documents (PDF)</label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control" id="pdfFile" accept=".pdf" multiple (change)="onSupportiveDocumentsChange($event)" #supportiveDocumentsInput>
                    <small class="form-text text-muted">Upload up to 3 PDFs (≤5MB each). ({{ supportiveDocuments.length }}/3 selected)</small>
                    <div *ngIf="supportiveDocError" class="text-danger small mt-1">{{ supportiveDocError }}</div>
                      <button type="button"  [disabled]="supportiveDocuments.length >= 3"
                    class="btn btn-outline-primary mr-2 float-right" 
                    (click)="supportiveDocumentsInput.click()" 
                    style="border-top-left-radius: 0; border-bottom-left-radius: 0; ">
                      <i class="fa fa-plus">Add More</i>
                    </button>

                  </div>
                  <div *ngIf="supportiveDocError" class="invalid-feedback d-block">
                    {{ supportiveDocError }}
                  </div>
                  <!-- <div *ngIf="modalForm.get('pdfFile')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('pdfFile')?.errors?.invalidType }}
                  </div>
                  <small id="pdfFileHelp" class="form-text text-muted">Upload a .pdf document.</small>
                  <button class="btn btn-danger" (click)="unloadPdfFile()">Cancel</button> -->
                  <!-- Documents Preview Subsection -->
                  <div class="preview-subsection">
                    <h6 class="bold-text mb-2">Documents Preview</h6>
                    <div *ngIf="supportiveDocuments.length === 0" class="text-muted">No PDF file selected.</div>
                      <ul class="list-unstyled mt-2">
                      <li *ngFor="let doc of supportiveDocuments; let i = index" class="d-flex align-items-center mb-1">
                        <i class="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                        <a [href]="doc.url" target="_blank">{{ doc.file.name }}</a>
                        <button type="button" class="badge bg-danger border-0 ms-2" style="width: 22px; height: 22px; border-radius: 50%; font-size: 1rem; display: flex; align-items: center; justify-content: center;" (click)="removeSupportiveDocument(i)" aria-label="Remove">&times;</button>
                      </li>

                    </ul>
                     <button type="button" *ngIf="supportiveDocuments.length > 0" [disabled]="supportiveDocuments.length >= 3"
                    class="btn btn-outline-primary" 
                    (click)="supportiveDocumentsInput.click()" 
                    style="border-top-left-radius: 0; border-bottom-left-radius: 0; ">
                      <i class="fa fa-plus">Add More</i>
                    </button>
                    <!-- No PDF preview, just the list above -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add Button -->
          <!-- <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn btn-success modern-btn" (click)="addSite()">Add Site</button>
          </div> -->
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
              <span class="text-muted modern-text-muted">
                Total Sites Added: <span class="badge bg-info">{{ sites.length }}</span>
              </span>
            </div>
            <button type="button" class="btn modern-btn btn-success"
            [disabled]="(selectedRow?.data['unitDD'] == '3' && (selectedRow?.data['quantity']  || selectedRow?.data['physicalTarget'] ||  selectedRow?.data['physicalTargetPrev'] || selectedRow?.data['physicalTargetCurr'] )- (selectedRow?.siteSpecifictaionCount) || 0) > 0 && sites.length == ((selectedRow?.data['quantity'] || selectedRow?.data['physicalTarget'] ||  selectedRow?.data['physicalTargetPrev'] || selectedRow?.data['physicalTargetCurr'])- (selectedRow?.siteSpecifictaionCount) || 0)"
             (click)="addSite()">
              <i class="bi bi-plus-circle me-1"></i>Add Site
            </button>
          </div>

        </form>

        <!-- List of Saved Sites -->
        <div class="saved-sites-list">
          <h5 class="bold-text mb-3">Sites to Submit</h5>
          <div *ngIf="sites.length === 0" class="text-muted">No sites added yet.</div>
          <div class="card mb-2" *ngFor="let site of sites; let i = index">
            <div class="card-body">
              <h2 class="bold-text text-center">Site-{{ i + 1 }}</h2>
              <p><strong>Remarks/Justification:</strong> {{ site.siteRemarks }}</p>
              <p><strong>KML File:</strong> {{ site.kmlFile?.name || 'None' }}</p>
              <div *ngIf="site.beforeImageMetadata && site.beforeImageMetadata.length > 0">
                <p class="mb-1"><strong>Before Images:</strong></p>
                <div class="d-flex flex-wrap gap-2 mb-2">
                  <div *ngFor="let img of site.beforeImageMetadata" class="position-relative">
                    <div class="image-preview-container" [ngClass]="img.fileSource || 'internal'" style="position: relative; display: inline-block;">
                      <img *ngIf="img.fileSource === 'external' && img.originalUrl" 
                           [src]="img.originalUrl" 
                           alt="External Image" 
                           class="img-thumbnail" 
                           style="width: 60px; height: 60px; object-fit: cover;">
                      <img *ngIf="img.fileSource === 'internal' && img.file" 
                           [src]="getImagePreviewUrl(img)" 
                           alt="Internal Image" 
                           class="img-thumbnail" 
                           style="width: 60px; height: 60px; object-fit: cover;">
                      <div class="image-source-badge" [ngClass]="img.fileSource || 'internal'">
                        {{ img.fileSource === 'external' ? 'EXT' : 'INT' }}
                      </div>
                      <div class="image-source-indicator" [ngClass]="img.fileSource || 'internal'">
                        {{ img.fileSource === 'external' ? 'Asset' : 'Device' }}
                      </div>
                    </div>
                    <div class="mt-1 small text-muted text-center" style="max-width: 60px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ img.fileSource === 'external' ? (img.originalUrl?.split('/').pop() || 'Asset Image') : (img.file?.name || 'Device Image') }}
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="site.supportiveDocuments && site.supportiveDocuments.length > 0">
                <p class="mb-1"><strong>Supportive Documents:</strong></p>
                <ul class="list-unstyled mb-2">
                  <li *ngFor="let doc of site.supportiveDocuments">
                    <span>{{ doc.name }}</span>
                  </li>
                </ul>
              </div>
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeSite(i)">Remove</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="modal-footer modern-footer">
        <button type="button" class="btn btn-secondary modern-btn" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary modern-btn" (click)="saveSiteInfo()">Submit All Sites</button>
      </div> -->
        <div class="modal-footer modern-footer">
          <span class="text-muted modern-text-muted me-auto" *ngIf="currentRow?.data['unitDD'] === '3'  ||  currentRow?.data['unitPrev'] == '3' || currentRow?.data['unitCurr'] == '3'">
          Total Sites: <span class="badge bg-info">{{ sites.length }}</span>
          / Required: <span class="badge bg-warning">{{ getRequiredSiteCount()}}</span>
        </span>
          <button type="button" class="btn btn-secondary modern-btn" (click)="closeModal()">
            <i class="bi bi-x-circle me-1"></i>Cancel
          </button>
          <button type="button" class="btn btn-primary  modern-btn"  (click)="saveAllSiteInfo()">
            <i class="bi bi-check-circle me-1"></i>Submit All Sites
          </button>
          <!-- [disabled]="(currentRow?.data['quantity'] || 0) > 0 && sites.length !== (currentRow?.data['quantity'] || 0)" -->
        </div>
    </div>
  </div>
</div>

<!-- Over-modal: Asset Select -->
<div class="modal show fade asset-select-modal" tabindex="-1"  
  *ngIf="assetSelectModalOpen" aria-modal="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content asset-modal-content">
      <div class="modal-header asset-modal-header">
        <h5 class="modal-title fw-bold">
          <i class="fa fa-database me-2"></i> Browse and Select Asset Images
          <span *ngIf="assetList.length > 0" class="badge bg-primary ms-2">{{ assetList.length }} Assets</span>
        </h5>
        <button type="button" class="btn-close" (click)="closeAssetSelectModal()">X</button>
      </div>
      <div class="modal-body asset-modal-body">
        <!-- Your asset form and image selection here -->
     
             
           <!-- Info Section (read-only) -->
        <div class="row g-2 align-items-end mb-3">
          <div class="col-md-4">
            <label class="form-label mb-1">Division</label>
            <div class="form-control bg-light fw-semibold">{{selectedAssetDivisionName}}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">Range</label>
            <div class="form-control bg-light fw-semibold">{{selectedAssetRangeName}}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">Financial Year</label>
            <div class="form-control bg-light fw-semibold">{{selectedAssetFinYear}}</div>
          </div>
        </div>
         <!-- Loading Spinner -->
        <div *ngIf="isAssetLoading" class="mb-2">
          <span class="spinner-border spinner-border-sm text-primary me-2"></span>
          Loading assets...
        </div>

          <!-- Asset List (multi-select) -->
        <div *ngIf="!isAssetLoading && assetList?.length > 0" class="mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="fw-bold text-primary">
              <i class="fa fa-database me-1"></i> Select Asset(s): 
              <span class="badge badge-primary ml-1">{{ getSelectedAssetsCount() }}/{{ assetList.length }}</span>
            </div>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-outline-primary" (click)="toggleAllAssets(true)">
                <i class="fa fa-check-square mr-1"></i> Select All
              </button>
              <button class="btn btn-outline-secondary" (click)="toggleAllAssets(false)">
                <i class="fa fa-square mr-1"></i> Deselect All
              </button>
            </div>
          </div>
          
          <!-- Asset Loading Spinner -->
          <div *ngIf="isLoadingAssets" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading assets...</span>
            </div>
            <p class="mt-2 text-muted">Loading assets...</p>
          </div>

          <!-- Asset Grid -->
          <div *ngIf="!isLoadingAssets && assetList.length > 0" class="row">
            <div *ngFor="let asset of assetPaginatedData" class="col-md-4 col-lg-3 mb-2">
              <div class="card asset-card" [class.selected]="asset.selected">
                <div class="card-body p-2">
                  <div class="form-check">
                    <input type="checkbox" 
                           class="form-check-input" 
                           [id]="'asset-' + asset.asset_serial_id"
                           [checked]="asset.selected"
                           (change)="onAssetSelectionChange(asset)" />
                    <label class="form-check-label font-weight-bold" [for]="'asset-' + asset.asset_serial_id">
                      {{ asset.asset_serial_id }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Asset Pagination -->
          <div *ngIf="!isLoadingAssets && assetTotalPages > 1" class="d-flex justify-content-between align-items-center mt-3">
            <div class="text-muted small">
              Showing {{ (assetCurrentPage - 1) * assetPageSize + 1 }} to {{ Math.min(assetCurrentPage * assetPageSize, assetTotalItems) }} of {{ assetTotalItems }} assets
            </div>
            <nav aria-label="Asset pagination">
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="assetCurrentPage === 1">
                  <a class="page-link" href="javascript:void(0)" (click)="changeAssetPage(assetCurrentPage - 1)">
                    <i class="fa fa-chevron-left"></i>
                  </a>
                </li>
                <li *ngFor="let page of getAssetPageNumbers()" class="page-item" [class.active]="page === assetCurrentPage">
                  <a class="page-link" href="javascript:void(0)" (click)="changeAssetPage(page)">{{ page }}</a>
                </li>
                <li class="page-item" [class.disabled]="assetCurrentPage === assetTotalPages">
                  <a class="page-link" href="javascript:void(0)" (click)="changeAssetPage(assetCurrentPage + 1)">
                    <i class="fa fa-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <!-- No Assets Message -->
          <div *ngIf="!isLoadingAssets && assetList.length === 0" class="text-center py-4">
            <i class="fa fa-folder-open fa-3x text-muted mb-3"></i>
            <p class="text-muted">No assets found for the selected criteria.</p>
          </div>
          
          <button class="btn btn-info btn-sm mt-3" (click)="getImagesForSelectedAssets()"
                  [disabled]="getSelectedAssetsCount() === 0">
            <i class="fa fa-image me-1"></i> Load Images ({{ getSelectedAssetsCount() }} selected)
          </button>
        </div>
        <div *ngIf="!isAssetLoading && assetList?.length === 0" class="text-muted mb-2">
          No assets found for this selection.
        </div>

          <!-- Images Grid -->
        <div *ngIf="assetImages?.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="fw-bold text-success">
              <i class="fa fa-picture-o mr-1"></i> Select Images to Import: 
              <span class="badge badge-success ml-1">{{ getSelectedImagesCount() }}/{{ assetImages.length }}</span>
            </div>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-outline-success" (click)="toggleAllImages(true)">
                <i class="fa fa-check-square mr-1"></i> Select All
              </button>
              <button class="btn btn-outline-secondary" (click)="toggleAllImages(false)">
                <i class="fa fa-square mr-1"></i> Deselect All
              </button>
            </div>
          </div>
          
          <!-- Image Loading Spinner -->
          <div *ngIf="isLoadingImages" class="text-center py-4">
            <div class="spinner-border text-success" role="status">
              <span class="sr-only">Loading images...</span>
            </div>
            <p class="mt-2 text-muted">Loading images...</p>
          </div>

          <!-- Image Grid -->
          <div *ngIf="!isLoadingImages && assetImages.length > 0" class="row">
            <div *ngFor="let img of imagePaginatedData; let i = index" class="col-md-3 col-lg-2 mb-3">
              <div class="card image-card" [class.selected]="img.selected">
                <div class="position-relative">
                  <img [src]="img.image_url" 
                       class="card-img-top img-thumbnail"
                       style="height: 120px; object-fit: cover; cursor: pointer;"
                       [style.boxShadow]="img.selected ? '0 0 12px 2px #28a745cc' : ''"
                       (click)="viewAssetImage(img.image_url, img.asset_serial_id)"
                       [title]="'Click to view full size - Asset: ' + img.asset_serial_id" />
                  
                  <div class="checkbox-overlay" style="z-index: 9999; margin: 5px;">
                    <div class="custom-checkbox-wrapper" style="background: white; border-radius: 4px; padding: 2px; box-shadow: 0 4px 8px rgba(0,0,0,0.6); display: inline-block;">
                      <input type="checkbox" 
                             [id]="'image-' + i"
                             [checked]="img.selected"
                             (change)="onImageSelectionChange(img)"
                             style="width: 20px; height: 20px; margin: 0; cursor: pointer; accent-color: #28a745;" />
                    </div>
                  </div>
                  
                  <div class="mt-2 p-2" 
                       style="background: rgba(0,0,0,0.7); color: white; font-size: 0.75rem; border-radius: 0 0 4px 4px;">
                    <div class="text-truncate">{{ img.asset_serial_id }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Image Pagination -->
          <div *ngIf="!isLoadingImages && imageTotalPages > 1" class="d-flex justify-content-between align-items-center mt-3">
            <div class="text-muted small">
              Showing {{ (imageCurrentPage - 1) * imagePageSize + 1 }} to {{ Math.min(imageCurrentPage * imagePageSize, imageTotalItems) }} of {{ imageTotalItems }} images
            </div>
            <nav aria-label="Image pagination">
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="imageCurrentPage === 1">
                  <a class="page-link" href="javascript:void(0)" (click)="changeImagePage(imageCurrentPage - 1)">
                    <i class="fa fa-chevron-left"></i>
                  </a>
                </li>
                <li *ngFor="let page of getImagePageNumbers()" class="page-item" [class.active]="page === imageCurrentPage">
                  <a class="page-link" href="javascript:void(0)" (click)="changeImagePage(page)">{{ page }}</a>
                </li>
                <li class="page-item" [class.disabled]="imageCurrentPage === imageTotalPages">
                  <a class="page-link" href="javascript:void(0)" (click)="changeImagePage(imageCurrentPage + 1)">
                    <i class="fa fa-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <!-- No Images Message -->
          <div *ngIf="!isLoadingImages && assetImages.length === 0 && imagesLoaded" class="text-center py-4">
            <i class="fa fa-images fa-3x text-muted mb-3"></i>
            <p class="text-muted">No images found for selected asset(s).</p>
          </div>
          
          <div class="d-flex justify-content-between align-items-center mt-3">
            <button class="btn btn-success" (click)="importSelectedAssetImages()"
                    [disabled]="getSelectedImagesCount() === 0 || isAssetLoading">
              <i class="fa fa-arrow-down me-1"></i> 
              Import {{ getSelectedImagesCount() }} Image(s) to {{ currentImportTarget === 'before' ? 'Before' : 'After' }} Images
              <span *ngIf="isAssetLoading" class="spinner-border spinner-border-sm ms-1"></span>
            </button>
            
            <button class="btn btn-outline-secondary" (click)="closeAssetSelectModal()">
              <i class="fa fa-times me-1"></i> Cancel
            </button>
          </div>
        </div>
        <div *ngIf="assetImages && assetImages.length === 0 && imagesLoaded" class="text-muted text-center py-3">
          No images found for selected asset(s).
        </div>

      
    </div>
    <div class="modal-footer modern-footer" style="background: #f8f9fa; border-top: none;">
      <button class="btn btn-secondary modern-btn" (click)="closeAssetSelectModal()">
        <i class="fa fa-times me-1"></i> Close
      </button>
    </div>
   
    </div>
  </div>
</div>


<!-- Site Details View Modal -->
<div class="modal fade modern-modal show" *ngIf="isSiteDetailsModalOpen" style="display: block;" tabindex="-1">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header modern-header">
        <h5 class="modal-title">📄 Sites Details</h5>
        <button type="button" class="btn-close" (click)="isSiteDetailsModalOpen = false">&times;</button>
      </div>
      <div class="modal-body" style="background: #f8f9fa;">
        <div class="accordion custom-accordion" id="siteSpecAccordion">
          <!-- Section 1: Site Specification -->
          <div class="accordion-panel mb-4" style="background: #fff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); padding: 1.5rem;">
            <div class="accordion-header mb-2" (click)="toggleSection(1)" style="cursor:pointer;">
              <h5 class="mb-0">1. Site Justification</h5>
              <span>{{ sectionOpen[1] ? '−' : '+' }}</span>
            </div>
            <div class="accordion-content" *ngIf="sectionOpen[1]">
              <div class="panel-content">
                <div class="mb-4">
                  <label class="fw-bold">1.1 KML File:</label>
                  <ng-container *ngIf="siteDetailsData?.siteSpecification?.siteSpecKML; else noKml">
                    <span class="me-2">{{ siteDetailsData.siteSpecification.siteSpecKML.name }}</span>
                    <button class="btn btn-sm btn-primary me-2" (click)="DownloadFile({documentPath: siteDetailsData.siteSpecification.siteSpecKML.name})">Download</button>
                    <app-apogeometrymapview *ngIf="siteDetailsData.siteSpecification.siteSpecKML.geojson" 
                      [mapPreviewGeojsonInfo]="{geojson: siteDetailsData.siteSpecification.siteSpecKML.geojson, geojsonProps: siteDetailsData.siteSpecification.siteSpecKML.geojsonProps}"
                 >
                    </app-apogeometrymapview>
                  </ng-container>
                  <ng-template #noKml><span class="text-muted">No KML file available.</span></ng-template>
                </div>
                <div class="mb-4">
                  <label class="fw-bold">1.2 Before Images:</label>
                  <div class="d-flex flex-wrap gap-3">
                    <ng-container *ngIf="siteDetailsData?.siteSpecification?.siteSpecImages?.length > 0; else noBeforeImages">
                      <div *ngFor="let img of siteDetailsData.siteSpecification.siteSpecImages" class="position-relative">
                        <div class="image-preview-container" [ngClass]="img.fileSource || 'internal'" style="position: relative; display: inline-block;">
                          <img [src]="img.fileSource === 'external' ? img.filePath : (baseUrlFile + img.filePath)" 
                               class="img-thumbnail me-2 mb-2" 
                               style="max-height: 100px; cursor: pointer; border-radius: 8px; box-shadow: 0 1px 4px rgba(0,0,0,0.08);" 
                               alt="" 
                               (click)="viewSiteImage(img.fileSource === 'external' ? img.filePath : (baseUrlFile + img.filePath))">
                          <div class="image-source-badge" [ngClass]="img.fileSource || 'internal'">
                            {{ img.fileSource === 'external' ? 'EXT' : 'INT' }}
                          </div>
                          <div class="image-source-indicator" [ngClass]="img.fileSource || 'internal'">
                            {{ img.fileSource === 'external' ? 'Asset' : 'Device' }}
                          </div>
                        </div>
                        <div class="mt-1 small text-muted text-center" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          {{ img.name }}
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #noBeforeImages><span class="text-muted">No before images available.</span></ng-template>
                  </div>
                </div>
                <div class="mb-2">
                  <label class="fw-bold">1.3 Supportive Documents:</label>
                  <ul class="ps-3">
                    <ng-container *ngIf="siteDetailsData?.siteSpecification?.siteSpecDocs?.length > 0; else noSupportiveDocs">
                      <li *ngFor="let doc of siteDetailsData.siteSpecification.siteSpecDocs" class="mb-1">
                        <a [href]="baseUrlFile + doc.filePath" target="_blank">{{ doc.name }}</a>
                      </li>
                    </ng-container>
                    <ng-template #noSupportiveDocs><li class="text-muted">No supportive documents available.</li></ng-template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Section 2: Site Execution -->
          <div class="accordion-panel mb-4" style="background: #fff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); padding: 1.5rem;">
            <div class="accordion-header mb-2" (click)="toggleSection(2)" style="cursor:pointer;">
              <h5 class="mb-0">2. Site Execution </h5>
              <span>{{ sectionOpen[2] ? '−' : '+' }}</span>
            </div>
            <div class="accordion-content" *ngIf="sectionOpen[2]">
              <div class="panel-content">
                <!-- Site Execution Map View -->
                <div class="mb-4">
                  <label class="fw-bold">2.1 Execution KML File:</label>
                  <ng-container *ngIf="siteDetailsData?.siteExecution?.execKML; else noExecKml">
                    <span class="me-2">{{ siteDetailsData.siteExecution.execKML.name }}</span>
                    <button class="btn btn-sm btn-primary me-2" (click)="DownloadFile({documentPath: siteDetailsData.siteExecution.execKML.name})">Download</button>
                    <app-apogeometrymapview *ngIf="siteDetailsData.siteExecution.execKML.geojson" 
                      [mapPreviewGeojsonInfo]="{geojson: siteDetailsData.siteExecution.execKML.geojson, geojsonProps: siteDetailsData.siteExecution.execKML.geojsonProps}"
                   >
                    </app-apogeometrymapview>
                  </ng-container>
                  <ng-template #noExecKml><span class="text-muted">No KML file available.</span></ng-template>
                </div>
                <div class="mb-4">
                  <label class="fw-bold">2.1 After Images:</label>
                  <div class="d-flex flex-wrap gap-3">
                    <ng-container *ngIf="siteDetailsData?.siteExecution?.execImages?.length > 0; else noAfterImages">
                      <div *ngFor="let img of siteDetailsData.siteExecution.execImages" class="position-relative">
                        <div class="image-preview-container" [ngClass]="img.fileSource || 'internal'" style="position: relative; display: inline-block;">
                          <img [src]="img.fileSource === 'external' ? img.filePath : (baseUrlFile + img.filePath)" 
                               class="img-thumbnail me-2 mb-2" 
                               style="max-height: 100px; cursor: pointer; border-radius: 8px; box-shadow: 0 1px 4px rgba(0,0,0,0.08);" 
                               (click)="viewSiteImage(img.fileSource === 'external' ? img.filePath : (baseUrlFile + img.filePath))">
                          <div class="image-source-badge" [ngClass]="img.fileSource || 'internal'">
                            {{ img.fileSource === 'external' ? 'EXT' : 'INT' }}
                          </div>
                          <div class="image-source-indicator" [ngClass]="img.fileSource || 'internal'">
                            {{ img.fileSource === 'external' ? 'Asset' : 'Device' }}
                          </div>
                        </div>
                        <div class="mt-1 small text-muted text-center" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          {{ img.name }}
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #noAfterImages><span class="text-muted">No after images available.</span></ng-template>
                  </div>
                </div>
                <div class="mb-2">
                  <label class="fw-bold">2.2 Documents:</label>
                  <ul class="ps-3">
                    <ng-container *ngIf="siteDetailsData?.siteExecution?.execDocs?.length > 0; else noExecDocs">
                      <li *ngFor="let doc of siteDetailsData.siteExecution.execDocs" class="mb-1">
                        <a [href]="baseUrlFile + doc.filePath" target="_blank">{{ doc.name }}</a>
                      </li>
                    </ng-container>
                    <ng-template #noExecDocs><li class="text-muted">No execution documents available.</li></ng-template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Section 3: Approval / Reject History (static for now) -->
          <div class="accordion-panel mb-2" style="background: #fff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); padding: 1.5rem;">
            <div class="accordion-header mb-2" (click)="toggleSection(3)" style="cursor:pointer;">
              <h5 class="mb-0">3. Approval / Reject History</h5>
              <span>{{ sectionOpen[3] ? '−' : '+' }}</span>
            </div>
            <div class="accordion-content" *ngIf="sectionOpen[3]">
              <div class="panel-content">
                <div *ngIf="isHistoryLoading" class="text-center py-3">
                  <div class="spinner-border text-primary"></div>
                </div>
                <div *ngIf="!isHistoryLoading && siteHistory.length">
                  <div *ngFor="let group of getHistoryGroupedByDesignation()">
                    <div class="timeline-level-header font-weight-bold text-primary mb-2 mt-4">
                      <i class="fa fa-shield mr-1"></i> {{ group.designation }}
                    </div>
                    <ul class="timeline-vertical">
                      <li *ngFor="let log of group.entries" class="timeline-item d-flex align-items-start mb-4">
                        <div class="timeline-icon mr-3"
                             [ngClass]="{
                               'bg-success': log.action === 'Approved' || log.action === 'Execution Approved',
                               'bg-danger': log.action === 'Rejected' || log.action === 'Execution Rejected',
                               'bg-info': log.action === 'Resubmitted' || log.action === 'Execution Resubmitted'
                             }"
                             style="width:2.2rem;height:2.2rem;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-size:1.2rem;">
                          <i class="fa"
                             [ngClass]="{
                               'fa-check': log.action === 'Approved' || log.action === 'Execution Approved',
                               'fa-times': log.action === 'Rejected' || log.action === 'Execution Rejected',
                               'fa-repeat': log.action === 'Resubmitted' || log.action === 'Execution Resubmitted'
                             }"></i>
                        </div>
                        <div class="timeline-content flex-fill bg-light rounded px-3 py-2 shadow-sm">
                          <div>
                            <span class="font-weight-bold">{{ log.action }}</span>
                            <span class="text-muted small ml-2">{{ log.actionTime | date:'medium' }}</span>
                          </div>
                          <div class="small text-secondary">
                            <i class="fa fa-user mr-1"></i>
                            <span [attr.title]="'Username: ' + log.user">
                              {{ log.fullName }}
                            </span>
                            <span class="text-muted ml-1">({{ log.user }})</span>
                            <span *ngIf="log.designation" class="text-info ml-1">[{{ log.designation }}]</span>
                          </div>
                          <div class="mt-1" *ngIf="log.remarks">{{ log.remarks }}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div *ngIf="!isHistoryLoading && !siteHistory.length" class="text-muted">No history found.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer modern-footer" style="background: #f8f9fa; border-top: none;">
        <button class="btn btn-secondary modern-btn" (click)="isSiteDetailsModalOpen = false">Close</button>
      </div>
    </div>
  </div>
</div>

   <!-- Modal for Site Specification NOT IN USED -->
    <div class="modal fade modern-modal" [class.show]="isModalSiteSpecificationOpen" [style.display]="isModalSiteSpecificationOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="additionalSiteModal" [attr.aria-hidden]="!isModalSiteSpecificationOpen">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header modern-header">
            <h5 class="modal-title bold-text" id="additionalSiteModal">Site Specification</h5>
            <button type="button" class="btn-close" (click)="closeSiteSpecificationModal()" aria-label="Close">X</button>
          </div>

          <div class="modal-body">
            <form [formGroup]="siteSpecificationForm" class="needs-validation" novalidate >
              <!-- Remarks/Justification -->
              <div class="card mb-3 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0 bold-text">1. Remarks/Justification</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label for="remarks" class="form-label bold-text">Remarks/Justification</label>
                      <!-- <textarea class="form-control form-control-sm" id="remarks" formControlName="remarks"
                                maxlength="1500" rows="4" placeholder="Enter your remarks (max 300 words)"
                                (input)="updateWordCount()"
                                [ngClass]="{'is-invalid': siteSpecificationForm.get('remarks')?.invalid && siteSpecificationForm.get('remarks')?.touched}">
                      </textarea>
                      <div class="d-flex justify-content-between mt-1">
                        <small class="text-muted">Word count: {{ wordCount }} / 300</small>
                        <small *ngIf="wordCount > 300" class="text-danger">Word limit exceeded!</small>
                      </div> -->
                        <textarea class="form-control form-control-sm" id="remarks" formControlName="remarks"
                                maxlength="300" rows="4" placeholder="Enter your remarks (max 300 characters)"
                                (input)="updateCharCount()"
                                [ngClass]="{'is-invalid': siteSpecificationForm.get('remarks')?.invalid && siteSpecificationForm.get('remarks')?.touched}">
                      </textarea>
                      <div class="d-flex justify-content-between mt-1">
                        <small class="text-muted">Character count: {{ charCount }} / 300</small>
                        <small *ngIf="charCount > 300" class="text-danger">Character limit exceeded!</small>
                      </div>
                      <div *ngIf="siteSpecificationForm.get('remarks')?.invalid && siteSpecificationForm.get('remarks')?.touched" class="invalid-feedback">
                        Remarks must be between 1 and 300 words.
                      </div>
                    </div>
                    <div class="col-md-12 text-end">
                      <button type="button" class="btn btn-sm btn-danger" (click)="resetRemarks()">Reset</button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Images Section -->
              <div class="card mb-3 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0 bold-text">2. Geotagged Images</h6>
                </div>
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-md-12">
                      <label for="siteImage" class="form-label bold-text">Upload Geotagged Images</label>
                      <div class="file-upload-wrapper d-flex align-items-center">
                        <input type="file" class="form-control modern-input me-2" id="siteImage" accept=".jpg,.jpeg,.png"
                               (change)="onSiteImageChange($event)" aria-describedby="siteImageHelp"  [disabled]="siteImages.length >= 5">
                        <button type="button" class="btn btn-sm btn-primary" 
                                [disabled]="!tempSiteImage || siteImages.length >= 5 || !tempSiteImageCoordinates">
                          Add Image
                        </button>
                      </div>
                      <small id="siteImageHelp" class="form-text text-muted">Upload a geotagged .jpg or .png image (max 5 images).Image must contain geotag data.</small>
                      <div *ngIf="siteImages.length >= 5" class="text-warning mt-1">
                        Maximum of 5 images reached.
                      </div>
                      <div *ngIf="tempSiteImage && !tempSiteImageCoordinates" class="text-danger mt-1">
                        Selected image does not contain geotag data.
                      </div>
                    </div>
                  </div>

                  <!-- Image Previews -->
                  <div class="row" *ngIf="siteImages.length > 0">
                    <div class="col-md-12">
                      <h6 class="bold-text mb-2">Uploaded Images</h6>
                      <div class="image-preview-container d-flex flex-wrap gap-3">
                        <div *ngFor="let image of siteImages; let i = index; trackBy: trackByIndex" 
                        class="image-preview-card position-relative  d-flex flex-column align-items-center">
                             <div *ngIf="image.coordinates" class="coordinates-badge mb-1 text-center">
                            <i class="bi bi-geo-alt-fill me-1 text-primary"></i>
                            <span class="coord-label">Lat:</span> {{ image.coordinates.latitude.toFixed(6) }},
                            <span class="coord-label ms-2">Lon:</span> {{ image.coordinates.longitude.toFixed(6) }}
                          </div>
                           <div class="position-relative">
   <img [src]="image.previewUrl" alt="Site Image Preview" class="img-thumbnail"
                               style="max-height: 120px; max-width: 120px; object-fit: cover;">
                       
                          <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0"
                                  (click)="removeSiteImage(i)" title="Remove Image">
                            <i class="fas fa-times"></i>
                          </button>
                           </div>
                       
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="siteImages.length === 0" class="text-muted">
                    No images uploaded yet.
                  </div>
                </div>
              </div>

              <!-- Documents Section -->
              <div class="card mb-3 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0 bold-text">3. Supportive Documents</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label for="supportiveDocument" class="form-label bold-text">Supportive Document</label>
                      <div class="file-upload-wrapper">
                        <input type="file" class="form-control modern-input" id="supportiveDocument" formControlName="supportiveDocument"
                               accept=".pdf,.doc,.docx" (change)="onSupportiveDocumentChange($event)" aria-describedby="supportiveDocumentHelp">
                        <span class="file-name">{{ siteSpecificationForm.get('supportiveDocument')?.value?.name || 'No file chosen' }}</span>
                      </div>
                      <div *ngIf="siteSpecificationForm.get('supportiveDocument')?.errors?.invalidType" class="invalid-feedback d-block">
                        {{ siteSpecificationForm.get('supportiveDocument')?.errors?.invalidType }}
                      </div>
                      <small id="supportiveDocumentHelp" class="form-text text-muted">Upload a .pdf, .doc, or .docx document.</small>
                      <button type="button" class="btn btn-sm btn-danger mt-2" (click)="unloadSupportiveDocument()">Cancel</button>
                      <div class="preview-subsection mt-3">
                        <h6 class="bold-text mb-2">Document Preview</h6>
                        <div *ngIf="!supportiveDocumentPreviewUrl" class="text-muted">No document selected.</div>
                        <div *ngIf="supportiveDocumentPreviewUrl">
                          <p class="mb-1 small bold-text">Supportive Document:</p>
                          <a [href]="supportiveDocumentPreviewUrl" target="_blank" class="text-primary">
                            {{ supportiveDocumentFile.name }}
                          </a>
                        </div>

                   

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer modern-footer">
            <button type="button" class="btn btn-secondary modern-btn" (click)="closeSiteSpecificationModal()">Cancel</button>
            <button type="button" class="btn btn-primary modern-btn" (click)="saveSiteSpecification()">
              Save
            </button>
          </div>

       
        </div>
      </div>
    </div>
  <!-- Modal for Image View -->
  <div class="modal fade modern-modal image-view-modal" [class.show]="isImageModalOpen" [style.display]="isImageModalOpen ? 'block' : 'none'">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header modern-header">
          <h5 class="modal-title bold-text">
            <i class="fa fa-image mr-2"></i>View Image
          </h5>
          <button type="button" class="btn-close" (click)="closeImageModal()">X</button>
        </div>
        <div class="modal-body p-0" style="background: #f8f9fa;">
          <!-- Image Controls Toolbar -->
          <div class="image-controls-toolbar p-3" style="background: white; border-bottom: 1px solid #dee2e6;">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-outline-primary btn-sm" (click)="rotateImage('left')" title="Rotate Left">
                    <i class="fa fa-rotate-left"></i> Rotate Left
                  </button>
                  <button type="button" class="btn btn-outline-primary btn-sm" (click)="rotateImage('right')" title="Rotate Right">
                    <i class="fa fa-rotate-right"></i> Rotate Right
                  </button>
                </div>
                <div class="btn-group ml-2" role="group">
                  <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetImageTransform()" title="Reset">
                    <i class="fa fa-refresh"></i> Reset
                  </button>
                </div>
              </div>
              <div class="col-md-6 text-end">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-outline-success btn-sm" (click)="setImageFit('contain')" title="Fit to Screen">
                    <i class="fa fa-expand"></i> Fit Screen
                  </button>
                  <button type="button" class="btn btn-outline-success btn-sm" (click)="setImageFit('fill')" title="Fill Screen">
                    <i class="fa fa-arrows-alt"></i> Fill Screen
                  </button>
                  <button type="button" class="btn btn-outline-success btn-sm" (click)="setImageFit('original')" title="Original Size">
                    <i class="fa fa-search"></i> Original
                  </button>
                </div>
                <div class="btn-group ml-2" role="group">
                  <button type="button" class="btn btn-outline-info btn-sm" (click)="zoomIn()" title="Zoom In">
                    <i class="fa fa-search-plus"></i>
                  </button>
                  <button type="button" class="btn btn-outline-info btn-sm" (click)="zoomOut()" title="Zoom Out">
                    <i class="fa fa-search-minus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Image Container -->
          <div class="image-container" style="height: 70vh; overflow: auto; display: flex; align-items: center; justify-content: center; padding: 20px;">
            <img [src]="selectedImagePath" 
                 alt="Document Image" 
                 class="img-fluid document-preview" 
                 *ngIf="selectedImagePath"
                 [style.transform]="imageTransform"
                 [style.object-fit]="imageFit"
                 [style.max-width]="imageFit === 'original' ? 'none' : '100%'"
                 [style.max-height]="imageFit === 'original' ? 'none' : '100%'"
                 [style.width]="imageFit === 'fill' ? '100%' : 'auto'"
                 [style.height]="imageFit === 'fill' ? '100%' : 'auto'"
                 style="transition: transform 0.3s ease, object-fit 0.3s ease; cursor: move;" />
          </div>
        </div>
        <div class="modal-footer modern-footer">
          <div class="d-flex justify-content-between w-100">
            <div class="text-muted small">
              <span *ngIf="imageRotation !== 0">Rotation: {{ imageRotation }}°</span>
              <span *ngIf="imageZoom !== 1" class="ml-2">Zoom: {{ (imageZoom * 100).toFixed(0) }}%</span>
            </div>
            <button type="button" class="btn btn-sm btn-secondary custom-btn modern-btn" (click)="closeImageModal()">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
   <!-- Modal for Map View -->
  <div class="modal fade modern-modal" [class.show]="isMapModalOpen">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header modern-header">
          <h5 class="modal-title bold-text">Mapview</h5>
          <button type="button" class="btn-close" (click)="closeMapModal()">X</button>
        </div>
        <div class="modal-body" style="min-height: 100%; padding: 0;">
              <app-apogeometrymapview *ngIf="mapPreviewGeojsonInfo" [mapPreviewGeojsonInfo]="mapPreviewGeojsonInfo"></app-apogeometrymapview>
          
        </div>
        <div class="modal-footer modern-footer">
          <button type="button" class="btn btn-sm btn-secondary custom-btn modern-btn" (click)="closeMapModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Upload Excel Modal -->
<div class="modal" [ngClass]="{'show d-block': isUploadExcelModalOpen}" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header  modern-header">
         <h5 class="modal-title bold-text">Upload Excel File</h5>
          <button type="button" class="btn-close" (click)="closeUploadExcelModal()">X</button>
       
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="uploadExcelModal">Select Excel File</label>
          <input type="file" class="form-control" id="uploadExcelModal" accept=".xlsx,.xls" (change)="onExcelFileChange($event)" [disabled]="isLoading">
          <small class="form-text text-muted">Only .xlsx and .xls files are allowed.</small>
          <div *ngIf="selectedExcelFile" class="mt-2">
            <p>Selected file: {{ selectedExcelFile.name }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-success" (click)="uploadExcelForm()" [disabled]="!selectedExcelFile || isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Upload
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeUploadExcelModal()" >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
   <!-- Modal for Execution -->
 <div class="modal fade modern-modal " [class.show]="isExecutionModalOpen" [style.display]="isExecutionModalOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="exceutionInfoModal" [attr.aria-hidden]="!isExecutionModalOpen">
  <div class="modal-dialog  modal-xl">
    <div class="modal-content">
      <div class="modal-header modern-header">
        <h5 class="modal-title bold-text" id="exceutionInfoModal">Execution</h5>
        <button type="button" class="btn-close" (click)="closeExecutionModal()" aria-label="Close">X</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="executionForm" class="needs-validation" novalidate>
          <!-- Remarks/Justification -->
          <div class="card mb-3 shadow-sm">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">1. Remarks</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="remarks" class="form-label bold-text">Remarks/Justification</label>
                  <textarea class="form-control form-control-sm" id="remarks" formControlName="remarks"
                            maxlength="300" rows="4" placeholder="Enter your remarks (max 300 characters)"
                            (input)="updateExecutionCharCount()"
                            [ngClass]="{'is-invalid': executionForm.get('remarks')?.invalid && executionForm.get('remarks')?.touched}">
                  </textarea>
                  <div class="d-flex justify-content-between mt-1">
                    <small class="text-muted">Character count: {{ executionForm.get('remarks')?.value?.length || 0 }} / 300</small>
                    <small *ngIf="executionForm.get('remarks')?.value?.length > 300" class="text-danger">Character limit exceeded!</small>
                  </div>
                  <div *ngIf="executionForm.get('remarks')?.invalid && executionForm.get('remarks')?.touched" class="invalid-feedback">
                    Remarks must be between 1 and 300 characters.
                  </div>
                </div>
                <div class="col-md-12 text-end">
                  <button type="button" class="btn btn-sm btn-danger" (click)="resetExecutionRemarks()">Reset</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Map View Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">2. Map View</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="kmlFile" class="form-label bold-text">Geography (KML File)
                  </label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control modern-input" id="kmlFileExecution" formControlName="kmlFile" accept=".kml"
                      (change)="onExecutionKmlFileChange($event)" aria-describedby="kmlFileHelpExecution">
                    <span class="file-name">{{ executionForm.get('kmlFile')?.value?.name || 'No file chosen' }}</span>
                  </div>
                  <div *ngIf="executionForm.get('kmlFile')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ executionForm.get('kmlFile')?.errors?.invalidType }}
                  </div>
                  <small id="kmlFileHelpExecution" class="form-text text-muted">Upload a .kml file for geographic data.</small>
                  <button type="button" class="btn btn-danger" (click)="unloadExcecutionKMLFile()">Cancel</button>
                </div>
              </div>
              <!-- Map View Preview Subsection -->
              <div class="preview-subsection mb-4"> 
                <h6 class="bold-text mb-2">Map View Preview</h6>
                <div *ngIf="!executionForm.get('kmlFile')?.value" class="text-muted">No KML file selected.</div>
                     <app-map-preview *ngIf="kmlFile" [kmlFile]="kmlFile"></app-map-preview>
              </div>
            </div>
          </div>

          <!-- Images Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">3. After Images</h6>
            </div>
            <div class="card-body">
              <div class="mb-2">
                <label for="afterImage" class="form-label bold-text">After Images</label>
                <div class="file-upload-wrapper">
                  <input type="file" class="form-control modern-input" id="afterImage" accept=".jpg,.jpeg,.png" multiple (change)="onAfterImageChange($event)" #afterImageInput>
                  <small class="form-text text-muted">Upload up to 5 GeoTag images (.jpg, .jpeg, .png, ≤5MB each). ({{ afterImages.length }}/5 selected)</small>
                  <div *ngIf="afterImageError" class="text-danger small mt-1 mr-1">{{ afterImageError }}</div>
                  <button type="button" [disabled]="afterImages.length >= 5" class="btn btn-outline-primary float-right" (click)="afterImageInput.click()" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                    <i class="fa fa-plus">Upload From Device</i>
                  </button>
                 
                </div>
                <!-- Preview Section -->
                <div class="d-flex flex-wrap mt-3">
                  <ng-container *ngFor="let img of afterImages; let i = index">
                    <div class="me-2 mb-2 position-relative">
                      <div class="image-preview-container" [ngClass]="img.fileSource || 'internal'" style="position: relative; display: inline-block;">
                        <img [src]="img.preview" class="img-thumbnail" style="max-height: 100px; max-width: 120px; border-radius: 8px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); cursor:pointer;" (click)="viewSiteImage(img.preview)">
                        <div class="image-source-badge" [ngClass]="img.fileSource || 'internal'">
                          {{ img.fileSource === 'external' ? 'EXT' : 'INT' }}
                        </div>
                        <div class="image-source-indicator" [ngClass]="img.fileSource || 'internal'">
                          {{ img.fileSource === 'external' ? 'Asset' : 'Device' }}
                        </div>
                        <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0" style="z-index:4;" (click)="removeAfterImage(i)">&times;</button>
                      </div>
                    </div>
                  </ng-container>
                    <button type="button" *ngIf="afterImages.length>0" [disabled]="afterImages.length >= 5" class="btn btn-outline-primary float-right" (click)="afterImageInput.click()" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                    <i class="fa fa-plus"> Add More</i>
                  </button>
                </div>
                         <!-- Browse Asset Repository -->
                  <span class="mx-2 text-muted" style="font-weight: 500;">OR</span>

                 
                  <button
                    type="button"
                    class="btn btn-info"
                    [disabled]="afterImages.length >= 5"
                    (click)="openAssetSelectModal('after')">
                    <i class="fa fa-database me-1"></i> Browse Asset Repository
                  </button>
              </div>
            </div>
          </div>
          <!-- Documents Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 font-weight-bold">4. Documents</h6>
            </div>
            <div class="card-body">
              <div formArrayName="docFormArray">
                <div *ngFor="let docCtrl of docFormArray.controls; let i = index" [formGroupName]="i" class="mb-3 border rounded p-3" #docUploadBlock>
                  <label class="form-label font-weight-bold">{{ docCtrl.get('typeName')?.value }}</label>
                  <div class="file-upload-wrapper d-flex align-items-center">
                    <input type="file" class="form-control modern-input me-2" accept=".pdf" (change)="onBrowseSelect($event, i)">
                    <button type="button" class="btn btn-outline-primary ms-2" (click)="docUploadBlock.nativeElement.querySelector('input[type=file]').click()" [disabled]="!!docCtrl.get('file')?.value">
                      <i class="fa fa-upload"></i> Upload
                    </button>
                   
                  </div>
                  <div *ngIf="docCtrl.get('file')?.value" class="mt-2 mr-2">
                    <i class="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                    <a [href]="docCtrl.get('previewUrl')?.value" target="_blank">{{ docCtrl.get('file')?.value?.name }}</a>
                  </div>
                   <button type="button" class="btn btn-outline-danger ms-2" (click)="removeFile(i)" *ngIf="!!docCtrl.get('file')?.value">
                      <i class="fa fa-times"></i> Remove
                    </button>
                  <div *ngIf="docCtrl.get('error')?.value" class="text-danger small mt-1">{{ docCtrl.get('error')?.value }}</div>
                </div>
              </div>
            </div>
          </div>

          </form>
      </div>

        <div class="modal-footer modern-footer">
          <button type="button" class="btn btn-secondary modern-btn" (click)="closeExecutionModal()">
            <i class="bi bi-x-circle me-1"></i>Cancel
          </button>
          <button type="button" class="btn btn-primary  modern-btn"  (click)="saveAllExecution()">
            <i class="bi bi-check-circle me-1"></i>Submit
          </button>
        </div>
    </div>
  </div>
</div>
<!-- Reject Modal -->
<div class="modal fade show custom-modal-overlay" *ngIf="rejectModalOpen" style="display: block;" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-4 shadow-lg">
      <div class="modal-header bg-warning bg-gradient text-dark align-items-center">
        <i class="fa fa-exclamation-triangle fa-lg me-2"></i>
        <h5 class="modal-title fw-bold">Reject Site</h5>
        <button type="button" class="btn-close ms-auto" (click)="closeRejectModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <label class="form-label fw-semibold">Remarks <span class="text-danger">*</span></label>
        <textarea class="form-control rounded-3 border-warning" [(ngModel)]="rejectRemarks" rows="4" maxlength="300" placeholder="Enter rejection remarks (required)"></textarea>
        <div class="d-flex justify-content-between mt-1">
          <small class="text-muted">{{ rejectRemarks.length || 0 }}/300</small>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary rounded-pill px-4" (click)="closeRejectModal()">Cancel</button>
        <button class="btn btn-danger rounded-pill px-4" [disabled]="!rejectRemarks.trim()" (click)="confirmReject()">
          <i class="fa fa-times me-1"></i>Reject
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Resubmit Modal -->
<div class="modal fade show custom-modal-overlay" *ngIf="resubmitModalOpen" style="display: block;" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-4 shadow-lg">
      <div class="modal-header bg-info bg-gradient text-dark align-items-center">
        <i class="fa fa-repeat fa-lg me-2"></i>
        <h5 class="modal-title fw-bold">Resubmit Site</h5>
        <button type="button" class="btn-close ms-auto" (click)="closeResubmitModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-2">
          <label class="form-label fw-semibold">Last Rejection Remarks</label>
          <div class="alert alert-warning rounded-3 py-2 px-3 mb-2">
            <i class="fa fa-exclamation-circle text-danger me-2"></i>
            {{ selectedSiteForAction?.rejectionRemarks || 'N/A' }}
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label fw-semibold">Resubmission Deadline</label>
          <div class="alert alert-info rounded-3 py-2 px-3 mb-2">
            <i class="fa fa-clock text-primary me-2"></i>
            {{ selectedSiteForAction?.resubmissionDeadline | date:'mediumDate' }}
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label fw-semibold">Site Name</label>
          <input class="form-control rounded-3" [(ngModel)]="resubmitFields.taskName" />
        </div>
        <div class="mb-2">
          <label class="form-label fw-semibold">Remarks</label>
          <textarea class="form-control rounded-3" [(ngModel)]="resubmitFields.siteRemarks" rows="3" maxlength="300"></textarea>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary rounded-pill px-4" (click)="closeResubmitModal()">Cancel</button>
        <button class="btn btn-primary rounded-pill px-4" (click)="confirmResubmit()">
          <i class="fa fa-repeat me-1"></i>Resubmit
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Rejection Modal (Reusable for Justification/Execution) -->
<div class="modal fade show" tabindex="-1" role="dialog"
     [ngStyle]="{display: (rejectJustificationModalOpen || rejectExecutionModalOpen) ? 'block' : 'none'}"
     *ngIf="rejectJustificationModalOpen || rejectExecutionModalOpen">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded shadow">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">
          <i class="fa fa-times-circle mr-2"></i>
          {{ rejectJustificationModalOpen ? 'Reject Site Specification' : 'Reject Site Execution' }}
        </h5>
        <button type="button" class="close" (click)="rejectJustificationModalOpen ? closeRejectJustificationModal() : closeRejectExecutionModal()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="rejectRemarks">Remarks <span class="text-danger">*</span></label>
          <textarea id="rejectRemarks" class="form-control" [(ngModel)]="rejectRemarks" rows="4" maxlength="300" placeholder="Enter rejection remarks (required)"></textarea>
          <small class="form-text text-muted">{{ rejectRemarks.length || 0 }}/300</small>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary rounded-pill" (click)="rejectJustificationModalOpen ? closeRejectJustificationModal() : closeRejectExecutionModal()">Cancel</button>
        <button type="button" class="btn btn-danger rounded-pill"
                [disabled]="!rejectRemarks.trim()"
                (click)="rejectJustificationModalOpen ? confirmRejectJustification() : confirmRejectExecution()">
          <i class="fa fa-times"></i> Reject
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Approve Confirmation Modal -->
<div class="modal fade show" tabindex="-1" role="dialog"
     [ngStyle]="{display: approveConfirmOpen ? 'block' : 'none'}"
     *ngIf="approveConfirmOpen">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded shadow">
      <div class="modal-header bg-success text-white">
        <h5 class="modal-title">
          <i class="fa fa-check-circle mr-2"></i>
          Confirm Approve {{ approveType === 'justification' ? 'Site Specification' : 'Site Execution' }}
        </h5>
        <button type="button" class="close" (click)="closeApproveConfirm()">&times;</button>
      </div>
      <div class="modal-body">
        <p>
          Are you sure you want to <b>approve</b>
          {{ approveType === 'justification' ? 'this Site Specification' : 'this Site Execution' }}?
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary rounded-pill" (click)="closeApproveConfirm()">Cancel</button>
        <button type="button" class="btn btn-success rounded-pill" (click)="confirmApprove()">
          <i class="fa fa-check"></i> Yes, Approve
        </button>
      </div>
    </div>
  </div>
</div>

</div>

  <div id="footer">
    <app-masterfooter></app-masterfooter>
  </div>
  </div>
